
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shopping-cart",
      function () {
        return require("private-next-pages/shopping-cart/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shopping-cart"])
      });
    }
  